import { Button, Grid, Paper, TextField, Typography, Box } from "@mui/material";
import { useState } from "react";
import { IInscricao } from "shared/features/api/inscricao/types";
import { useTheme } from "@mui/material/styles";

interface SimuladorProps {
  inscricoes: IInscricao;
  etapaNome: string;
}

export const SimuladorNotaCorte: React.FC<SimuladorProps> = ({
  inscricoes,
  etapaNome,
}) => {
  const theme = useTheme();
  const [aprovados, setAprovados] = useState<number>(0);
  const [reprovados, setReprovados] = useState<number>(0);
  const [notaCorte, setNotaCorte] = useState<number>(0);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  const simular = (notaCorte: number) => {
    const quantAprovados = inscricoes.elementos.reduce(
      (contador, inscricao) => {
        const etapaAlvo = inscricao.inscricaoEtapas.find(
          (etapa) => etapa.nomeEtapa === etapaNome
        );

        if (etapaAlvo && etapaAlvo.nota >= notaCorte) {
          return contador + 1;
        }

        return contador;
      },
      0
    );

    const quantReprovados = inscricoes.elementos.reduce(
      (contador, inscricao) => {
        const etapaAlvo = inscricao.inscricaoEtapas.find(
          (etapa) => etapa.nomeEtapa === etapaNome
        );

        if (etapaAlvo && etapaAlvo.nota < notaCorte) {
          return contador + 1;
        }

        return contador;
      },
      0
    );

    setAprovados(quantAprovados);
    setReprovados(quantReprovados);
  };

  const handleNotaCorteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (!regex.test(value)) {
      setError(true);
      setHelperText("Por favor, insira apenas números.");
      return;
    }

    const parsedValue = parseFloat(value);

    if (value === "") {
      setError(false);
      setHelperText("");
    } else if (isNaN(parsedValue)) {
      setError(true);
      setHelperText("Valor inválido.");
    } else if (parsedValue < 0 || parsedValue > 10) {
      setError(true);
      setHelperText("A nota deve estar entre 0 e 10.");
    } else {
      setError(false);
      setHelperText("");
      setNotaCorte(parseFloat(value));
    }
  };

  return (
    <Paper
      sx={{
        p: { xs: 1, sm: 2 },
        gridColumn: { xs: "auto", md: "span 3" },
        width: "100%",
      }}
    >
      <Typography
        variant="subtitle1"
        gutterBottom
        fontSize={{ xs: 14, sm: 16 }}
      >
        Simular nota de corte
      </Typography>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={8}>
          <TextField
            fullWidth
            size="small"
            placeholder="0"
            onChange={handleNotaCorteChange}
            error={error}
            helperText={helperText}
            inputProps={{
              inputMode: "decimal",
              pattern: "[0-9]*[.]?[0-9]*",
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            fullWidth
            size="medium"
            onClick={() => simular(notaCorte)}
            disabled={error}
          >
            SIMULAR
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", gap: 2, mt: 2, width: "100%" }}>
        <Box
          sx={{
            flex: 1,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "4px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Typography fontSize={{ xs: 12, sm: 14 }}>Aprovados</Typography>
          <Typography fontSize={{ xs: 12, sm: 14 }}>{aprovados}</Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "4px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Typography fontSize={{ xs: 12, sm: 14 }}>Reprovados</Typography>
          <Typography fontSize={{ xs: 12, sm: 14 }}>{reprovados}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};
